import { jsx as _jsx } from "react/jsx-runtime";
import { TeaserItem } from '@lichtblick/photon/molecules/teaser-item/teaser-item';
import { getHref } from '../../helpers/links';
import { photonColorMap } from '../../utils/colors';
import { AImage } from '../AImage/AImage';
import { AVideo } from '../AVideo/AVideo';
export const MTeaserItem = ({ accentColor, button, chip, className, headline, media, text, textOutside = false, trackingIdentifier })=>{
    const buttonData = button[0];
    const href = getHref(buttonData);
    const tracking = trackingIdentifier ? {
        eventName: trackingIdentifier
    } : undefined;
    const image = media?.[0]?.component === 'a-image' ? /*#__PURE__*/ _jsx(AImage, {
        ...media[0]
    }) : undefined;
    const video = media?.[0]?.component === 'a-video' ? /*#__PURE__*/ _jsx(AVideo, {
        ...media[0]
    }) : undefined;
    return /*#__PURE__*/ _jsx(TeaserItem, {
        backgroundColor: accentColor ? photonColorMap[accentColor] : undefined,
        chip: chip,
        className: className,
        headline: headline,
        link: {
            title: buttonData.text ?? '',
            href,
            isDownloadLink: buttonData.isDownloadLink ?? false,
            shouldOpenInNewTab: buttonData.openInNewTab ?? false
        },
        media: image || video,
        text: text,
        textOutside: textOutside,
        tracking: tracking
    });
};

//# sourceMappingURL=MTeaserItem.js.map